import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import Modal from '../../Modal/Modal';
import Heading from '../../Typography/Heading/Heading';
import Button from '../../Button/Button';
import styles from './DeleteModal.module.scss';
import { useAppDispatch, useAppSelector } from '../../../store/reducers';
import cn from 'classnames';
import Loader from '../../Loader/Loader';
import { clearData } from '../../../store/reducers/Guild/slice';
const DeleteModal = ({ closeModal, title, onClick, buttonName, label }) => {
    const { pending, error, isDataSent } = useAppSelector((state) => state.guild);
    const dispatch = useAppDispatch();
    useEffect(() => {
        if (!error && isDataSent.includes(label)) {
            closeModal();
            dispatch(clearData(label));
        }
    }, [error, isDataSent, dispatch, closeModal, label]);
    return (_jsxs(Modal, Object.assign({ background: true, closeModal: closeModal }, { children: [_jsx(Heading, { className: styles.heading, title: title }), pending.includes(label) ? (_jsx(Button, { className: cn('w-100 flex-1'), height: 'sm', size: '100', type: 'submit', text: "", icon: _jsx(Loader, { isTransparent: true }) })) : (_jsx(Button, { onClick: onClick, size: '100', height: 'sm', text: buttonName }))] })));
};
export default DeleteModal;
